import React from "react";
import { ThemedParagraph } from "../../../components/utilities";

const NoConnectionsMessage = () => {
    return <ThemedParagraph variant="muted" className="m-0">There are no Client Connections available for this account. Try creating one with the option above.</ThemedParagraph>
};

export default NoConnectionsMessage;